module.exports = __webpack_public_path__ + "files/3924a9013211d385a178e87b571a824e.png";